import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetLeadTagMaps as GetLeadTagMapsQuery,
    GetLeadTagMaps_lead_tagMaps_edges as LeadTagMapsEdge,
    GetLeadTagMapsVariables,
} from 'nutshell-graphql-types';

import GET_LEAD_TAG_MAPS from '../queries/get-lead-tag-maps.graphql';

export const useGetLeadTagMaps = (
    id?: string | null,
    number?: number | null
): {
    leadTagMaps: LeadTagMapsEdge[];
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<GetLeadTagMapsQuery, GetLeadTagMapsVariables>(
        GET_LEAD_TAG_MAPS,
        {
            variables: {
                // @ts-expect-error
                id,
                number,
            },
        }
    );

    return {
        leadTagMaps: data && data.lead && data.lead.tagMaps ? data.lead.tagMaps.edges : [],
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
